import * as React from 'react';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { Box, TextField, DialogActions, Button, DialogContent, DialogContentText, DialogTitle, Dialog, RadioGroup, FormControlLabel, FormLabel, FormControl, Radio } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import DescriptionAlerts from './Alert';
import SendIcon from '@mui/icons-material/Send';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: theme.palette.common.black,
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const InvoiceTable = ({ invoices }) => {
    console.log(invoices)
    const navigate = useNavigate()
    const [open, setOpen] = useState(false);
    const [editInvoiceId, setEditInvoiceId] = useState('')
    const [updatedRepairCost, setUpdatedRepairCost] = useState('')
    const [deleteId, setDeleteId] = useState('')
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false)
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severity, setSeverity] = useState('')
    const [alertMessage, setAlertMessage] = useState('')
    const [updatedPaymentStatus, setUpdatedPaymentStatus] = useState('')

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };

    const editButtonClicked = (invoice) => {
        setEditInvoiceId(invoice._id)
        setUpdatedRepairCost(invoice.repairCost)
        setUpdatedPaymentStatus(invoice.paymentStatus)
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setEditInvoiceId('')
        setUpdatedRepairCost('')
        setUpdatedPaymentStatus('')
    };

    const handleOpenDelete = () => {
        setDeleteDialogOpen(true)
    }

    const handleCloseDelete = () => {
        setDeleteDialogOpen(false)
        setDeleteId('')
    }

    const deleteButtonClicked = (id) => {
        setDeleteId(id)
    }

    useEffect(() => {
        if (deleteId) {
            handleOpenDelete()
        }
    }, [deleteId])

    useEffect(() => {
        if (editInvoiceId) {
            handleClickOpen();
        }
    }, [editInvoiceId]);

    const handleRepairCost = (e) => {
        setUpdatedRepairCost(e.target.value)
    }

    const handlePaymentStatus = (e) => {
        setUpdatedPaymentStatus(e.target.value)
    }

    const handleUpdate = () => {
        const token = localStorage.getItem('token')
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        };
        axios.put(`${process.env.REACT_APP_API_URL}/invoice/update/${editInvoiceId}`, {
            repairCost: parseFloat(updatedRepairCost),
            paymentStatus: updatedPaymentStatus
        }, { headers })
            .then((response) => {
                console.log(response)
                setEditInvoiceId('')
                setUpdatedRepairCost('')
                handleClose()
                setSeverity('success')
                setAlertMessage(response.data.message)
                setOpenSnackbar(true);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }).catch((err) => {
                console.log(err)
                setSeverity('error')
                setAlertMessage(err?.response?.data?.message)
                setOpenSnackbar(true);
                if (err?.response?.status === 401) {
                    setTimeout(() => {
                        navigate('/')
                    }, 1000);
                }
            })
    }

    const handleDelete = () => {
        const token = localStorage.getItem('token')
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        axios.delete(`${process.env.REACT_APP_API_URL}/invoice/delete/${deleteId}`, { headers })
            .then((response) => {
                setDeleteId(false)
                handleCloseDelete()
                setSeverity('success')
                setAlertMessage('Invoice deleted sucessfully')
                setOpenSnackbar(true);
                setTimeout(() => {
                    window.location.reload();
                }, 1000);
            }).catch((err) => {
                console.log(err)
                setSeverity('error')
                setAlertMessage(err?.response?.data?.message)
                setOpenSnackbar(true);
                if (err?.response?.status === 401) {
                    setTimeout(() => {
                        navigate('/')
                    }, 1000);
                }
            })
    }

    const SendMailButtonClicked = (invoice) => {
        const token = localStorage.getItem('token')
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
        axios.get(`${process.env.REACT_APP_API_URL}/invoice/sendinvoice/${invoice._id}/${invoice.application}`, { headers })
            .then((response) => {
                setDeleteId(false)
                handleCloseDelete()
                console.log("okok")
                setSeverity('success')
                setAlertMessage('Invoice has been send with the mail sucessfully')
                setOpenSnackbar(true);
            }).catch((err) => {
                console.log(err)
                console.log("okok 2")
                setSeverity('error')
                setAlertMessage(err?.response?.data?.message)
                setOpenSnackbar(true);
                if (err?.response?.status === 401) {
                    setTimeout(() => {
                        navigate('/')
                    }, 1000);
                }
            })
        console.log("ok 2")
    }

    return (
        <Box>
            <DescriptionAlerts openSnackbar={openSnackbar} handleCloseSnackbar={handleCloseSnackbar} severity={severity} alertMessage={alertMessage} />
            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', mt: '30px', mb: '30px', ml: '30px', mr: '30px' }}>
                <TableContainer component={Paper} align='center'>
                    <Table sx={{ minWidth: 700 }} aria-label="customized table">
                        <TableHead>
                            <TableRow>
                                <StyledTableCell>Invoice No</StyledTableCell>
                                <StyledTableCell align="left">RepairCost</StyledTableCell>
                                <StyledTableCell align="left">TotalPayment</StyledTableCell>
                                <StyledTableCell align="left">PaymentStatus</StyledTableCell>
                                <StyledTableCell align="left">SendInvoice</StyledTableCell>
                                <StyledTableCell align="left">Edit</StyledTableCell>
                                <StyledTableCell align="letf">Delete</StyledTableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {invoices.map((invoice) => (
                                <StyledTableRow key={invoice._id} sx={{ ":hover": { backgroundColor: '#666' } }}>
                                    <StyledTableCell component="th" scope="row">
                                        {invoice.invoiceNo}
                                    </StyledTableCell>

                                    <StyledTableCell component="th" scope="row">
                                        {invoice.repairCost}
                                    </StyledTableCell>

                                    <StyledTableCell component="th" scope="row">
                                        {invoice.total}
                                    </StyledTableCell>

                                    <StyledTableCell component="th" scope="row">
                                        {invoice.paymentStatus}
                                    </StyledTableCell>

                                    <StyledTableCell align="left" scope="row"><SendIcon sx={{
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '30px',
                                        ":hover": {
                                            backgroundColor: 'black',
                                            color: 'white'
                                        }
                                    }} onClick={() => SendMailButtonClicked(invoice)} /></StyledTableCell>

                                    <StyledTableCell align="left"><EditIcon sx={{
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '30px',
                                        ":hover": {
                                            backgroundColor: 'black',
                                            color: 'white'
                                        }
                                    }} onClick={() => editButtonClicked(invoice)} /></StyledTableCell>
                                    <StyledTableCell align="left"><DeleteIcon sx={{
                                        borderRadius: '50%',
                                        width: '40px',
                                        height: '30px',
                                        ":hover": {
                                            backgroundColor: 'black',
                                            color: 'white'
                                        }
                                    }} onClick={() => deleteButtonClicked(invoice._id)} /></StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>



            <Box>
                <Dialog open={open} onClose={handleClose}>
                    <DialogTitle sx={{ backgroundColor: 'black', color: 'white', textAlign: 'center' }}>Update invoice</DialogTitle>
                    <DialogContent sx={{ mt: '10px' }}>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="repairCost"
                            label="RepairCost"
                            type="text"
                            fullWidth
                            variant="standard"
                            defaultValue={updatedRepairCost}
                            onChange={handleRepairCost}
                        />
                        <FormControl sx={{ mt: '10px' }}>
                            <FormLabel id="demo-radio-buttons-group-label">PaymentStatus</FormLabel>
                            <RadioGroup
                                onChange={handlePaymentStatus}
                            >
                                <FormControlLabel value={'Pending'} control={<Radio />} label='Pending' />
                                <FormControlLabel value={'Completed'} control={<Radio />} label='Completed' />
                            </RadioGroup>
                        </FormControl>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: 'black',
                                width: '50%',
                                color: 'white',
                                ":hover": {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    cursor: 'pointer'
                                },
                            }} onClick={handleClose}>Cancel</Button>
                        <Button
                            sx={{
                                backgroundColor: 'black',
                                color: 'white',
                                width: '50%',
                                ":hover": {
                                    backgroundColor: '#50C878',
                                    color: 'white',
                                    cursor: 'pointer'
                                },
                            }}
                            onClick={handleUpdate}
                        >Update</Button>
                    </DialogActions>
                </Dialog>
            </Box>


            <Box>
                <Dialog open={deleteDialogOpen} onClose={handleCloseDelete}>
                    <DialogContent sx={{ mt: '10px', }}>
                        <DialogContentText >
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>

                            </Box>
                            Are you sure!
                            Do you want to delete it?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            sx={{
                                backgroundColor: 'black',
                                width: '50%',
                                color: 'white',
                                ":hover": {
                                    backgroundColor: 'red',
                                    color: 'white',
                                    cursor: 'pointer'
                                },
                            }} onClick={handleCloseDelete}>No! Don't</Button>
                        <Button
                            sx={{
                                backgroundColor: 'black',
                                color: 'white',
                                width: '50%',
                                ":hover": {
                                    backgroundColor: '#50C878',
                                    color: 'white',
                                    cursor: 'pointer'
                                },
                            }}
                            onClick={handleDelete}
                        >yes, please</Button>
                    </DialogActions>
                </Dialog>
            </Box>
        </Box>
    );
}

export default InvoiceTable